import { render } from "./DictTable.vue?vue&type=template&id=54239c01&scoped=true"
import script from "./DictTable.vue?vue&type=script&lang=js"
export * from "./DictTable.vue?vue&type=script&lang=js"

import "./DictTable.vue?vue&type=style&index=0&id=54239c01&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54239c01"

export default script